import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_BRANDREQUESTITEM,
  CREATE_BRANDREQUESTITEM,
  FETCH_BRANDREQUESTITEM,
  FETCH_BRANDREQUESTITEM_LIST,
  UPDATE_BRANDREQUESTITEM,
} from './brandRequestItem.actions';
import { BrandRequestItem, BrandRequestItemState } from './brandRequestItem.types';

const getInitialBrandRequestItemState = ():BrandRequestItem  => ({});

const initialState: BrandRequestItemState = {
  errorMessage: '',
  item: getInitialBrandRequestItemState(),
  items: [],
  loading: false,
  totalItems: 0,
};

export default (state: BrandRequestItemState = initialState, action: AppAction): BrandRequestItemState => {
  switch (action.type) {
    case REQUEST(FETCH_BRANDREQUESTITEM_LIST):
    case REQUEST(CREATE_BRANDREQUESTITEM):
    case REQUEST(FETCH_BRANDREQUESTITEM):
    case REQUEST(UPDATE_BRANDREQUESTITEM):
      return { ...state, loading: true };
    case SUCCESS(FETCH_BRANDREQUESTITEM_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_BRANDREQUESTITEM_LIST):
    case FAILURE(CREATE_BRANDREQUESTITEM):
    case FAILURE(FETCH_BRANDREQUESTITEM):
    case FAILURE(UPDATE_BRANDREQUESTITEM):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(CREATE_BRANDREQUESTITEM):
    case SUCCESS(FETCH_BRANDREQUESTITEM):
    case SUCCESS(UPDATE_BRANDREQUESTITEM):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_BRANDREQUESTITEM:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
